import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { db } from '../db';
import { shopItems } from '../data/shopItems';
import { toast } from '../utils/feedback';
import { ShoppingBag, Lock, CheckCircle, Eye, X, Sparkles, Info } from 'lucide-react';
import Mascot from '../components/Mascot';

export const ChestIcon = ({ type }) => {
  let colors = {
    wood: "#D68B3C",
    darkWood: "#BA6D26",
    border: "#4B2D10",
    shield: "#F3BA48",
    shadow: "#D49645",
    glow: "rgba(255, 215, 0, 0.3)"
  };
  
  if (type === 'chest_epic') {
    colors = {
      wood: "#a29bfe",
      darkWood: "#6c5ce7",
      border: "#2d3436",
      shield: "#dfe6e9",
      shadow: "rgba(108, 92, 231, 0.2)",
      glow: "rgba(108, 92, 231, 0.5)"
    };
  } else if (type === 'chest_legendary') {
    colors = {
      wood: "#e74c3c",
      darkWood: "#c0392b",
      border: "#1e272e",
      shield: "#f1c40f",
      shadow: "rgba(241, 196, 15, 0.3)",
      glow: "rgba(241, 196, 15, 0.8)"
    };
  }

  const isLegendary = type === 'chest_legendary';

  return (
    <svg width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ filter: `drop-shadow(0 0 ${isLegendary ? '20px' : '10px'} ${colors.glow})`, margin: '0 auto', display: 'block' }}>
      
      {/* Background Glow for Legendary */}
      {isLegendary && (
        <defs>
          <radialGradient id="legGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#f1c40f" stopOpacity="0.6"/>
            <stop offset="100%" stopColor="#f39c12" stopOpacity="0"/>
          </radialGradient>
        </defs>
      )}
      
      {/* Clip path for lid */}
      <defs>
        <clipPath id="lidClip">
          <path d="M 5 45 C 5 5, 95 5, 95 45 Z" />
        </clipPath>
      </defs>

      {isLegendary && <circle cx="50" cy="50" r="45" fill="url(#legGlow)" opacity="0.8" />}

      {/* Shadow */}
      <ellipse cx="50" cy="90" rx="45" ry="8" fill={colors.shadow} />

      {/* Main Base Back */}
      <rect x="5" y="45" width="90" height="35" rx="2" fill={colors.darkWood} stroke={colors.border} strokeWidth="3"/>
      
      {/* Planks */}
      <line x1="5" y1="56" x2="95" y2="56" stroke={colors.border} strokeWidth="3" />
      <line x1="5" y1="67" x2="95" y2="67" stroke={colors.border} strokeWidth="3" />

      {/* Base Feet */}
      <path d="M 2 80 L 98 80 L 92 88 L 8 88 Z" fill={colors.shield} stroke={colors.border} strokeWidth="3" strokeLinejoin="round"/>
      <path d="M 12 88 C 12 83, 88 83, 88 88 Z" fill={colors.shadow} stroke={colors.border} strokeWidth="3" />

      {/* Vault Lid */}
      <path d="M 5 45 C 5 5, 95 5, 95 45 Z" fill={colors.wood} stroke={colors.border} strokeWidth="3"/>
      
      {/* Lid Planks */}
      <path d="M 7 35 C 30 22, 70 22, 93 35" fill="none" stroke={colors.border} strokeWidth="3" clipPath="url(#lidClip)"/>
      <path d="M 6 40 C 30 28, 70 28, 94 40" fill="none" stroke={colors.border} strokeWidth="3" clipPath="url(#lidClip)"/>
      <path d="M 9 28 C 35 12, 65 12, 91 28" fill="none" stroke={colors.border} strokeWidth="3" clipPath="url(#lidClip)"/>

      {/* Base Vertical Bands */}
      <line x1="25" y1="45" x2="25" y2="80" stroke={colors.shield} strokeWidth="6" strokeLinecap="round" />
      <line x1="75" y1="45" x2="75" y2="80" stroke={colors.shield} strokeWidth="6" strokeLinecap="round" />
      
      {/* Lid Vertical Bands */}
      <path d="M 25 45 C 25 25, 30 18, 50 10" fill="none" stroke={colors.shield} strokeWidth="6" strokeLinecap="round" clipPath="url(#lidClip)" />
      <path d="M 75 45 C 75 25, 70 18, 50 10" fill="none" stroke={colors.shield} strokeWidth="6" strokeLinecap="round" clipPath="url(#lidClip)" />

      {/* Border around everything just to make it bolder */}
      <rect x="5" y="45" width="90" height="35" rx="2" fill="none" stroke={colors.border} strokeWidth="3"/>

      {/* Horizontal Band */}
      <rect x="2" y="41" width="96" height="8" rx="2" fill={colors.shield} stroke={colors.border} strokeWidth="3"/>

      {/* Massive Shield Lock */}
      <path d="M 38 35 L 62 35 L 62 65 L 50 80 L 38 65 Z" fill={colors.shield} stroke={colors.border} strokeWidth="3" strokeLinejoin="round"/>
      <path d="M 42 42 L 58 42 L 58 63 L 50 72 L 42 63 Z" fill="none" stroke={colors.border} strokeWidth="1.5" opacity="0.6"/>

      {/* Mascot Logo Inside Shield */}
      <image href={type === 'chest_epic' ? "/logos/option_m_flex_cropped_darkblue.png" : "/logos/option_m_flex_cropped_brown.png"} x="40" y="44" width="20" height="20" />

      {/* Sparkles for Epic and Legendary */}
      {type !== 'chest_basic' && (
        <>
          <path d="M 15 25 L 18 15 L 21 25 L 31 28 L 21 31 L 18 41 L 15 31 L 5 28 Z" fill="#fff" opacity="0.9"/>
          <path d="M 80 20 L 82 13 L 84 20 L 91 22 L 84 24 L 82 31 L 80 24 L 73 22 Z" fill="#fff" opacity="0.8"/>
        </>
      )}
    </svg>
  );
};

const Shop = ({ currentProfile, updateProfileLocal }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'border');
  const [purchasingId, setPurchasingId] = useState(null);
  const [previewItem, setPreviewItem] = useState(null);
  const [openingChest, setOpeningChest] = useState(null);
  const [serverDate, setServerDate] = useState(null);

  React.useEffect(() => {
    // Fetch real internet time to prevent local time exploits
    fetch('https://worldtimeapi.org/api/timezone/Europe/Paris')
      .then(res => res.json())
      .then(data => {
        if (data && data.datetime) {
          setServerDate(data.datetime.split('T')[0]);
        }
      })
      .catch(() => console.warn("Could not fetch server time"));
  }, []);

  if (!currentProfile) return <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}><div className="spinner"></div></div>;

  const inventory = currentProfile.inventory || [];
  const equipped = currentProfile.equipped || {};
  const coins = currentProfile.coins || 0;
  const diamonds = currentProfile.diamonds || 0;

  const handlePurchase = async (item) => {
    try {
      setPurchasingId(item.id);
      
      const updatedProfile = { ...currentProfile };
      if (item.currency === 'coins') updatedProfile.coins -= item.price;
      if (item.currency === 'diamonds') updatedProfile.diamonds -= item.price;

      if (item.category === 'chest') {
        let gainedXp = 0;
        let gainedDiamonds = 0;

        if (item.id === 'chest_basic') {
          gainedXp = Math.floor(Math.random() * 101) + 100; // 100 to 200
          if (Math.random() < 0.10) gainedDiamonds = Math.floor(Math.random() * 5) + 1; // 1 to 5
        } else if (item.id === 'chest_epic') {
          gainedXp = Math.floor(Math.random() * 151) + 150; // 150 to 300
          if (Math.random() < 0.30) gainedDiamonds = Math.floor(Math.random() * 6) + 3; // 3 to 8
        } else if (item.id === 'chest_legendary') {
          gainedXp = Math.floor(Math.random() * 151) + 250; // 250 to 400
          gainedDiamonds = Math.floor(Math.random() * 7) + 6; // 6 to 12
        }

        const profileAfterPayment = { ...currentProfile };
        if (item.currency === 'coins') profileAfterPayment.coins -= item.price;
        if (item.currency === 'diamonds') profileAfterPayment.diamonds -= item.price;

        await db.updateProfile(profileAfterPayment);
        updateProfileLocal(profileAfterPayment);
        
        if (previewItem?.id === item.id) setPreviewItem(null);
        
        setOpeningChest({ status: 'shaking', item, rewards: { xp: gainedXp, diamonds: gainedDiamonds, coins: 0 } });
        setTimeout(() => {
          setOpeningChest(prev => prev ? { ...prev, status: 'revealed' } : null);
        }, 1500);

      } else {
        await db.purchaseItem(currentProfile.id, item);
        updatedProfile.inventory = [...(updatedProfile.inventory || []), item.id];
        updateProfileLocal(updatedProfile);
        toast.success(`Achat réussi : ${item.name} !`);
        if (previewItem?.id === item.id) setPreviewItem(null);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setPurchasingId(null);
    }
  };

  const handleClaimChestRewards = async () => {
    if (!openingChest) return;
    try {
      const profileWithRewards = { ...currentProfile };
      profileWithRewards.xp = (profileWithRewards.xp || 0) + (openingChest.rewards.xp || 0);
      profileWithRewards.diamonds = (profileWithRewards.diamonds || 0) + (openingChest.rewards.diamonds || 0);
      profileWithRewards.coins = (profileWithRewards.coins || 0) + (openingChest.rewards.coins || 0);
      
      await db.updateProfile(profileWithRewards);
      updateProfileLocal(profileWithRewards);
      
      setOpeningChest(null);
    } catch (err) {
      toast.error("Erreur lors de la récupération des récompenses");
      setOpeningChest(null);
    }
  };

  const handleEquip = async (item) => {
    try {
      await db.equipItem(currentProfile.id, item.category, item.id);
      
      const updatedProfile = { ...currentProfile };
      if (!updatedProfile.equipped) updatedProfile.equipped = {};
      
      if (updatedProfile.equipped[item.category] === item.id) {
        updatedProfile.equipped[item.category] = null;
        toast.success(`${item.name} déséquipé.`);
      } else {
        updatedProfile.equipped[item.category] = item.id;
        toast.success(`${item.name} équipé !`);
      }
      
      updateProfileLocal(updatedProfile);
    } catch (err) {
      toast.error("Erreur lors de l'équipement");
    }
  };

  const handleGlobalThemePreview = (themeItem) => {
    toast.success(`Aperçu du thème ${themeItem.name} pendant 3s...`);
    
    // Notify App.jsx to handle the preview
    window.dispatchEvent(new CustomEvent('themePreview', { detail: themeItem.id }));
    
    // After 3s, revert to equipped theme or default
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('themePreviewEnd'));
      toast.success("Fin de l'aperçu.");
    }, 3000);
  };

  const itemsToShow = shopItems.filter(i => i.category === activeTab).sort((a, b) => {
    if (a.currency !== b.currency) {
      return a.currency === 'coins' ? -1 : 1;
    }
    return a.price - b.price;
  });

  const renderPreviewContent = (item) => {
    if (!item) return null;
    
    if (item.category === 'border') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem', padding: '2rem 0' }}>
          <div className={item.className || ''} style={{ width: '150px', height: '150px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--bg-card)', ...item.style }}>
            <img loading="lazy" src={currentProfile.avatarUrl || `https://ui-avatars.com/api/?name=${currentProfile.name}&background=random`} alt="Avatar Preview" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
          </div>
          <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>{currentProfile.name}</span>
        </div>
      );
    }
    
    if (item.category === 'theme') {
      // Les thèmes sont maintenant prévisualisés globalement via handleGlobalThemePreview
      return null;
    }

    if (item.category === 'title') {
      return null;
    }

    if (item.category === 'mascot') {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 0' }}>
          <Mascot id={item.id} level={35} size={150} />
        </div>
      );
    }

    if (item.category === 'mascot_accessory') {
      const equippedMascot = equipped['mascot'];
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem 0', width: '100%' }}>
          <p style={{ fontSize: '1rem', color: 'var(--text-secondary)', marginBottom: '1rem', textAlign: 'center' }}>
            {equippedMascot ? "S'applique sur ton compagnon actuel :" : "S'appliquera sur ton compagnon :"}
          </p>
          <Mascot id={equippedMascot || 'mascot_blob'} level={35} size={150} previewAccessory={item.id} interactive={false} />
        </div>
      );
    }

    if (item.category === 'chest') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem 0' }}>
          <ChestIcon type={item.id} />
          <p style={{ fontSize: '1rem', color: 'var(--text-secondary)', textAlign: 'center', marginTop: '1rem' }}>
            {item.description}
          </p>
        </div>
      );
    }

    return null;
  };

  const handleDailyChest = async () => {
    const today = serverDate || new Date().toISOString().split('T')[0];
    if (currentProfile.lastDailyChestDate === today) {
      toast.info("Coffre quotidien déjà récupéré !");
      return;
    }
    
    const isMonday = new Date(serverDate ? serverDate + 'T12:00:00' : new Date()).getDay() === 1;
    const chestItem = isMonday ? shopItems.find(i => i.id === 'chest_epic') : {
      id: 'chest_daily',
      name: 'Coffre Journalier',
      description: 'Contient entre 20 et 52 pièces.',
      category: 'chest'
    };
    
    setPurchasingId('daily_chest');
    setTimeout(async () => {
      let gainedXp = Math.floor(Math.random() * 51) + 50;
      let gainedCoins = 0;
      let gainedDiamonds = 0;

      if (chestItem.id === 'chest_daily' || chestItem.id === 'chest_basic') {
        gainedCoins = Math.floor(Math.random() * (52 - 20 + 1)) + 20;
      } else if (chestItem.id === 'chest_epic') {
        gainedXp = Math.floor(Math.random() * 151) + 150;
        if (Math.random() < 0.30) gainedDiamonds = Math.floor(Math.random() * 6) + 3;
      }

      const profileAfterPayment = { ...currentProfile, lastDailyChestDate: today };
      await db.updateProfile(profileAfterPayment);
      updateProfileLocal(profileAfterPayment);

      setOpeningChest({ item: chestItem, status: 'shaking', rewards: { xp: gainedXp, diamonds: gainedDiamonds, coins: gainedCoins } });
      setPurchasingId(null);

      setTimeout(() => {
        setOpeningChest(prev => prev ? { ...prev, status: 'revealed' } : null);
      }, 1500);
    }, 1000);
  };

  const renderDailyChestCard = () => {
    const today = serverDate || new Date().toISOString().split('T')[0];
    const isClaimed = currentProfile.lastDailyChestDate === today;
    const isMonday = new Date(serverDate ? serverDate + 'T12:00:00' : new Date()).getDay() === 1;
    const chestName = isMonday ? 'Coffre Épique (Spécial Lundi)' : 'Coffre Journalier';
    
    return (
      <div key="daily_chest" className="card shop-card" style={{ 
        display: 'flex', flexDirection: 'column', 
        border: '2px solid var(--primary-color)',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: isClaimed ? 'none' : '0 0 20px rgba(108, 92, 231, 0.4)',
        background: 'linear-gradient(135deg, rgba(108, 92, 231, 0.15) 0%, rgba(108, 92, 231, 0.05) 100%)',
        opacity: isClaimed ? 0.7 : 1
      }}>
        <div style={{ position: 'absolute', top: 0, left: 0, backgroundColor: 'var(--primary-color)', color: 'white', padding: '0.4rem 1rem', borderBottomRightRadius: '12px', fontSize: '0.85rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Sparkles size={14} /> Quotidien Gratuit
        </div>
        
        <div style={{ flex: 1, paddingTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.8rem', alignItems: 'center', textAlign: 'center' }}>
          
          <div style={{ filter: isClaimed ? 'grayscale(100%)' : 'none', transform: 'scale(1)', margin: '0.5rem 0' }}>
            <ChestIcon type={isMonday ? 'chest_epic' : 'chest_basic'} />
          </div>

          <h3 style={{ margin: 0, fontSize: '1.1rem', color: 'var(--primary-color)', fontWeight: 'bold' }}>{chestName}</h3>
          <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
            {isClaimed ? "Reviens demain pour un nouveau coffre !" : "Une récompense t'attend, ouvre-la maintenant !"}
          </p>
          
          <div style={{ marginTop: 'auto', width: '100%', paddingTop: '0.5rem' }}>
            <button 
              className={`btn ${isClaimed ? 'btn-secondary' : 'btn-primary'}`}
              disabled={isClaimed || purchasingId === 'daily_chest'}
              onClick={handleDailyChest}
              style={{ width: '100%', padding: '0.6rem', fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}
            >
              {isClaimed ? <><CheckCircle size={18} /> Récupéré</> : purchasingId === 'daily_chest' ? 'Ouverture...' : 'Ouvrir Gratuitement'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="shop-page" style={{ paddingBottom: '2rem' }}>
      {/* Header Premium */}
      <div style={{ 
        display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', 
        marginBottom: '2rem', padding: '1.5rem', 
        background: 'linear-gradient(135deg, rgba(162,155,254,0.1) 0%, rgba(108,92,231,0.1) 100%)',
        borderRadius: 'var(--border-radius)', border: '1px solid rgba(162,155,254,0.3)',
        backdropFilter: 'blur(10px)'
      }}>
        <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', margin: 0, textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
          <ShoppingBag size={32} color="var(--primary-color)" /> La Boutique
        </h2>
        
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap', marginTop: window.innerWidth <= 768 ? '1rem' : '0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', backgroundColor: 'var(--bg-color)', padding: '0.5rem 1rem', borderRadius: '20px', border: '1px solid var(--border-color)', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)' }}>
            <span style={{ fontSize: '1.2rem' }}>🟡</span> <span style={{ fontWeight: '700', fontSize: '1rem' }}>{coins.toLocaleString()}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', backgroundColor: 'var(--bg-color)', padding: '0.5rem 1rem', borderRadius: '20px', border: '1px solid var(--border-color)', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)' }}>
            <span style={{ fontSize: '1.2rem' }}>💎</span> <span style={{ fontWeight: '700', fontSize: '1rem', color: '#00cec9' }}>{diamonds.toLocaleString()}</span>
          </div>
        </div>
      </div>

      {/* Tabs Design */}
      <div className="tabs shop-categories-tabs" style={{ display: 'flex', gap: '0.8rem', marginBottom: '2rem', overflowX: 'auto', paddingBottom: '0.5rem', paddingTop: '0.5rem', scrollbarWidth: 'none' }}>
        {[
          { id: 'border', label: 'Bordures' },
          { id: 'theme', label: 'Thèmes' },
          { id: 'title', label: 'Titres' },
          { id: 'mascot', label: 'Compagnons' },
          { id: 'mascot_accessory', label: 'Accessoires' },
          { id: 'chest', label: 'Coffres' }
        ].map(tab => (
          <button 
            key={tab.id}
            className={`btn ${activeTab === tab.id ? 'btn-primary' : 'btn-outline'}`} 
            style={{ 
              borderRadius: '25px', 
              padding: '0.5rem 1.2rem', 
              whiteSpace: 'nowrap',
              fontWeight: activeTab === tab.id ? 'bold' : 'normal',
              transition: 'all 0.3s ease'
            }}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Item Grid */}
      {activeTab === 'mascot' && (
        <div style={{ backgroundColor: 'rgba(108, 92, 231, 0.1)', padding: '1rem', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.5rem', border: '1px solid rgba(108, 92, 231, 0.3)' }}>
          <Info size={24} color="var(--primary-color)" style={{ flexShrink: 0 }} />
          <span style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', lineHeight: '1.4' }}>
            Les compagnons t'accompagnent et t'offrent un bonus d'XP et de pièces après chaque séance !
          </span>
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {activeTab === 'chest' && renderDailyChestCard()}
        {itemsToShow.map(item => {
          const isOwned = item.category !== 'chest' && inventory.includes(item.id);
          const isEquipped = equipped[item.category] === item.id;
          const canAfford = item.currency === 'coins' ? coins >= item.price : diamonds >= item.price;
          const isPurchasing = purchasingId === item.id;

          return (
            <div key={item.id} className="card shop-card" style={{ 
              display: 'flex', flexDirection: 'column', 
              border: isEquipped ? '2px solid var(--primary-color)' : '1px solid var(--border-color)',
              position: 'relative',
              overflow: 'hidden',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              boxShadow: isEquipped ? '0 0 15px rgba(108, 92, 231, 0.2)' : '0 4px 6px rgba(0,0,0,0.05)',
              cursor: 'default'
            }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 15px rgba(0,0,0,0.1)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = isEquipped ? '0 0 15px rgba(108, 92, 231, 0.2)' : '0 4px 6px rgba(0,0,0,0.05)'; }}
            >
              {isEquipped && (
                <div style={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'var(--primary-color)', color: 'white', padding: '0.3rem 0.8rem', borderBottomLeftRadius: '12px', fontSize: '0.8rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px', zIndex: 1 }}>
                  <CheckCircle size={14} /> Équipé
                </div>
              )}
              
              {item.themeMode && (
                <div style={{ position: 'absolute', top: '10px', left: '10px', backgroundColor: 'var(--bg-color)', color: 'var(--text-secondary)', padding: '0.2rem 0.6rem', borderRadius: '12px', fontSize: '0.75rem', border: '1px solid var(--border-color)', zIndex: 1, display: 'flex', alignItems: 'center', gap: '4px' }}>
                  {item.themeMode === 'light' ? '☀️ Clair' : '🌙 Sombre'}
                </div>
              )}
              {/* Bouton Loupe (Preview) */}
              {item.category !== 'title' && item.category !== 'chest' && !(item.category === 'theme' && isEquipped) && (
                <button 
                  className="btn-icon" 
                  style={{ position: 'absolute', top: isEquipped ? '35px' : '10px', right: '10px', zIndex: 2, backgroundColor: 'var(--bg-card)', padding: '0.4rem', borderRadius: '50%', boxShadow: '0 2px 5px rgba(0,0,0,0.2)', border: '1px solid var(--border-color)' }}
                  onClick={() => item.category === 'theme' ? handleGlobalThemePreview(item) : setPreviewItem(item)}
                  title="Aperçu"
                >
                  <Eye size={18} color="var(--primary-color)" />
                </button>
              )}
              
              {item.category === 'chest' ? (
                <div style={{ flex: 1, paddingTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.8rem', alignItems: 'center', textAlign: 'center' }}>
                  <div style={{ margin: '0.5rem 0' }}>
                    <ChestIcon type={item.id} />
                  </div>
                  <h3 style={{ margin: 0, fontSize: '1.1rem', color: 'var(--primary-color)', fontWeight: 'bold' }}>
                    {item.name}
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                    {item.description}
                  </p>
                </div>
              ) : (
                <>
                  <div style={{ marginTop: item.themeMode ? '1.5rem' : '0' }}>
                    <h3 style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem', paddingRight: '2rem' }}>
                      {item.name}
                      {item.currency === 'diamonds' && <Sparkles size={16} color="#00cec9" />}
                    </h3>
                  </div>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', flexGrow: 1, lineHeight: '1.4' }}>{item.description}</p>
                </>
              )}
              
              <div style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                {!isOwned ? (
                  <button 
                    className="btn btn-primary" 
                    onClick={() => handlePurchase(item)}
                    disabled={!canAfford || isPurchasing}
                    style={{ 
                      width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem', padding: '0.6rem',
                      background: canAfford ? 'var(--primary-color)' : 'var(--bg-color)',
                      color: canAfford ? 'var(--btn-primary-text, #fff)' : 'var(--text-secondary)',
                      border: canAfford ? 'none' : '1px solid var(--border-color)'
                    }}
                  >
                    {isPurchasing ? '...' : canAfford ? (
                      <>
                        {item.currency === 'coins' ? '🟡' : '💎'}
                        <span style={{ fontWeight: 'bold' }}>{item.price.toLocaleString()}</span>
                        Acheter
                      </>
                    ) : (
                      <>
                        <Lock size={16} /> <span style={{ fontWeight: 'bold' }}>{item.price.toLocaleString()}</span> {item.currency === 'coins' ? '🟡' : '💎'}
                      </>
                    )}
                  </button>
                ) : (
                  <button 
                    className={`btn ${isEquipped ? 'btn-outline' : ''}`}
                    style={{ 
                      width: '100%', padding: '0.6rem', fontWeight: 'bold', 
                      backgroundColor: isEquipped ? 'transparent' : 'var(--secondary-color)', 
                      color: isEquipped ? 'var(--secondary-color)' : 'var(--btn-secondary-text, #fff)',
                      borderColor: 'var(--secondary-color)' 
                    }}
                    onClick={() => handleEquip(item)}
                  >
                    {isEquipped ? 'Déséquiper' : 'Équiper'}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Preview Modal */}
      {previewItem && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '1rem' }} onClick={() => setPreviewItem(null)}>
          <div className="modal-content card" style={{ width: '100%', maxWidth: '500px', position: 'relative', overflow: 'hidden' }} onClick={e => e.stopPropagation()}>
            <button className="btn-icon" onClick={() => setPreviewItem(null)} style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}>
              <X size={24} />
            </button>
            
            <h3 style={{ marginBottom: '0.5rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '1rem' }}>
              Aperçu : {previewItem.name}
            </h3>
            
            <div style={{ padding: '1.5rem 0', minHeight: '200px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {renderPreviewContent(previewItem)}
            </div>

            {(!inventory.includes(previewItem.id) || previewItem.category === 'chest') && (
              <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid var(--border-color)', display: 'flex', justifyContent: 'flex-end', gap: '1rem', alignItems: 'center' }}>
                <span style={{ fontWeight: 'bold', fontSize: '1.2rem', color: (previewItem.currency === 'coins' ? coins >= previewItem.price : diamonds >= previewItem.price) ? 'inherit' : 'var(--danger-color)' }}>
                  {previewItem.currency === 'coins' ? '🟡' : '💎'} {previewItem.price}
                </span>
                <button 
                  className="btn btn-primary"
                  disabled={!(previewItem.currency === 'coins' ? coins >= previewItem.price : diamonds >= previewItem.price) || purchasingId === previewItem.id}
                  onClick={() => handlePurchase(previewItem)}
                >
                  {purchasingId === previewItem.id 
                    ? 'Achat...' 
                    : (previewItem.currency === 'coins' ? coins >= previewItem.price : diamonds >= previewItem.price)
                      ? 'Acheter maintenant'
                      : <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <Lock size={16} /> <span>{previewItem.price.toLocaleString()} {previewItem.currency === 'coins' ? '🟡' : '💎'}</span>
                        </div>}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Chest Opening Modal */}
      {openingChest && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.9)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white', textAlign: 'center' }}>
            {openingChest.status === 'shaking' ? (
              <div style={{ animation: 'shake 0.5s infinite', filter: 'drop-shadow(0 0 20px rgba(255, 215, 0, 0.5))' }}>
                <div style={{ transform: 'scale(1.4)' }}>
                  <ChestIcon type={openingChest.item?.id || 'chest_basic'} />
                </div>
              </div>
            ) : (
              <div style={{ animation: 'popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', filter: 'drop-shadow(0 0 30px rgba(255, 215, 0, 0.8))' }}>
                  <div style={{ 
                    position: 'absolute', 
                    width: '300px', height: '300px', 
                    background: 'repeating-conic-gradient(rgba(255,215,0,0.2) 0 15deg, transparent 15deg 30deg)', 
                    animation: 'spinSunburst 10s linear infinite', 
                    borderRadius: '50%', zIndex: -1,
                    WebkitMaskImage: 'radial-gradient(circle, black 10%, transparent 70%)'
                  }} />
                  <div style={{ transform: 'scale(1.4)', zIndex: 1 }}>
                    <ChestIcon type={openingChest.item?.id || 'chest_basic'} />
                  </div>
                </div>
                <h2 style={{ fontSize: '2rem', color: '#f1c40f', textShadow: '0 2px 10px rgba(241, 196, 15, 0.5)', margin: '1rem 0' }}>Coffre Ouvert !</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', fontSize: '1.5rem', fontWeight: 'bold' }}>
                  {openingChest.rewards.xp > 0 && (
                    <div style={{ color: '#4cd137', backgroundColor: 'rgba(76, 209, 55, 0.2)', padding: '0.5rem 1.5rem', borderRadius: '30px', border: '1px solid #4cd137' }}>
                      + {openingChest.rewards.xp} XP
                    </div>
                  )}
                  {openingChest.rewards.coins > 0 && (
                    <div style={{ color: '#f1c40f', backgroundColor: 'rgba(241, 196, 15, 0.2)', padding: '0.5rem 1.5rem', borderRadius: '30px', border: '1px solid #f1c40f' }}>
                      🟡 + {openingChest.rewards.coins} Pièces
                    </div>
                  )}
                  {openingChest.rewards.diamonds > 0 && (
                    <div style={{ color: '#00cec9', backgroundColor: 'rgba(0, 206, 201, 0.2)', padding: '0.5rem 1.5rem', borderRadius: '30px', border: '1px solid #00cec9' }}>
                      💎 + {openingChest.rewards.diamonds} Diamants
                    </div>
                  )}
                </div>
                <button 
                  className="btn btn-primary" 
                  style={{ marginTop: '2rem', padding: '0.8rem 2rem', fontSize: '1.2rem' }}
                  onClick={handleClaimChestRewards}
                >
                  Super !
                </button>
              </div>
            )}
          </div>
          <style>{`
            @keyframes shake {
              0% { transform: translate(1px, 1px) rotate(0deg); }
              10% { transform: translate(-1px, -2px) rotate(-1deg); }
              20% { transform: translate(-3px, 0px) rotate(1deg); }
              30% { transform: translate(3px, 2px) rotate(0deg); }
              40% { transform: translate(1px, -1px) rotate(1deg); }
              50% { transform: translate(-1px, 2px) rotate(-1deg); }
              60% { transform: translate(-3px, 1px) rotate(0deg); }
              70% { transform: translate(3px, 1px) rotate(-1deg); }
              80% { transform: translate(-1px, -1px) rotate(1deg); }
              90% { transform: translate(1px, 2px) rotate(0deg); }
              100% { transform: translate(1px, -2px) rotate(-1deg); }
            }
            @keyframes popIn {
              0% { transform: scale(0.5); opacity: 0; }
              100% { transform: scale(1); opacity: 1; }
            }
            @keyframes pulse {
              0% { transform: scale(0.8) rotate(0deg); opacity: 0.8; }
              100% { transform: scale(1.1) rotate(15deg); opacity: 1; }
            }
            @keyframes spinSunburst {
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}
    </div>
  );
};

export default Shop;
